import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

export default function AdminAccount() {
  const [email, setEmail] = useState("");
  const [form, setForm] = useState({ current_password: "", new_email: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  useEffect(() => { api.get("/admin/me").then((r) => setEmail(r.data.email)); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!form.current_password) return toast.error("Add meg a jelenlegi jelszót");
    if (!form.new_email && !form.new_password) return toast.error("Adj meg új emailt vagy új jelszót");
    if (form.new_password && form.new_password.length < 10) return toast.error("Az új jelszó legalább 10 karakter legyen");
    if (form.new_password && form.new_password !== form.confirm) return toast.error("A két jelszó nem egyezik");
    setSaving(true);
    try {
      const { data } = await api.post("/admin/account", {
        current_password: form.current_password,
        new_email: form.new_email || null,
        new_password: form.new_password || null,
      });
      localStorage.setItem("gb_admin_token", data.token);
      localStorage.setItem("gb_admin_email", data.email);
      setEmail(data.email);
      setForm({ current_password: "", new_email: "", new_password: "", confirm: "" });
      toast.success("Mentve. Legközelebb az új adatokkal lépj be.");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" ") : "Nem sikerült menteni");
    } finally { setSaving(false); }
  };

  return (
    <div className="space-y-6 max-w-xl" data-testid="admin-account">
      <div>
        <p className="section-label">Fiók</p>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#201B18] mt-1">Belépési adatok</h1>
        <p className="text-sm text-[#8C8075] mt-2">Jelenlegi email: <span className="font-semibold text-[#201B18]" data-testid="admin-account-email">{email}</span></p>
      </div>
      <form onSubmit={save} className="rounded-2xl bg-white border border-[#2C221E]/10 p-6 space-y-5">
        <div className="space-y-2">
          <Label htmlFor="cur">Jelenlegi jelszó</Label>
          <Input id="cur" type="password" value={form.current_password} onChange={(e) => update("current_password", e.target.value)} data-testid="account-current-password" autoComplete="current-password" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="nem">Új email <span className="text-[#8C8075] font-normal">(opcionális)</span></Label>
          <Input id="nem" type="email" value={form.new_email} onChange={(e) => update("new_email", e.target.value)} placeholder={email} data-testid="account-new-email" />
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="np">Új jelszó <span className="text-[#8C8075] font-normal">(min. 10 karakter)</span></Label>
            <Input id="np" type="password" value={form.new_password} onChange={(e) => update("new_password", e.target.value)} data-testid="account-new-password" autoComplete="new-password" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="cp">Új jelszó még egyszer</Label>
            <Input id="cp" type="password" value={form.confirm} onChange={(e) => update("confirm", e.target.value)} data-testid="account-confirm-password" autoComplete="new-password" />
          </div>
        </div>
        <Button type="submit" disabled={saving} data-testid="account-save" className="bg-[#2C221E] hover:bg-[#1a1310] text-[#FBF8F3] rounded-full">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <><KeyRound className="h-4 w-4 mr-2" /> Mentés</>}
        </Button>
      </form>
    </div>
  );
}
